import { FormType } from '../../../form-types';

export const peBeluga: FormType = {
  name: 'Premature Ejaculation Visit',
  olderVersions: ['pe'],
  questions: [
    {
      key: 'pe_sexAssignedAtBirth',
      next: {
        condition: {
          'pe_sexAssignedAtBirth.pe_sexAssignedAtBirth_female': true
        },
        key: 'pe_ineligible',
        els: 'pe_height'
      }
    },
    'pe_height',
    'pe_weight',
    'pe_duration',
    'pe_onset',
    'pe_timeToEjaculation',
    'pe_distress',
    {
      key: 'pe_previousTreatment',
      next: {
        condition: {
          'pe_previousTreatment.pe_previousTreatment_other': true
        },
        key: 'pe_previousTreatment_other_details',
        els: 'pe_erectionIssue'
      }
    },
    'pe_previousTreatment_other_details',
    'pe_erectionIssue',
    {
      key: 'pe_physicalExam',
      next: {
        condition: {
          'pe_physicalExam.pe_physicalExam_issues': true
        },
        key: 'pe_physicalExam_issues_details',
        els: 'pe_bloodPressure'
      }
    },
    'pe_physicalExam_issues_details',
    {
      key: 'pe_bloodPressure',
      next: {
        condition: {
          'pe_bloodPressure.pe_bloodPressure_yes': true
        },
        key: 'pe_bloodPressure_value',
        els: 'pe_cardiovascularSymptoms'
      }
    },
    'pe_bloodPressure_value',
    {
      key: 'pe_cardiovascularSymptoms',
      next: {
        switch: [
          {
            condition: {
              'pe_cardiovascularSymptoms.pe_cardiovascularSymptoms_legCramps':
                true
            },
            key: 'pe_cardiovascularSymptoms_details'
          },
          {
            condition: {
              'pe_cardiovascularSymptoms.pe_cardiovascularSymptoms_heartbeats':
                true
            },
            key: 'pe_cardiovascularSymptoms_details'
          },
          {
            condition: {
              'pe_cardiovascularSymptoms.pe_cardiovascularSymptoms_chestPainStairs':
                true
            },
            key: 'pe_ineligible'
          },
          {
            condition: {
              'pe_cardiovascularSymptoms.pe_cardiovascularSymptoms_chestPainSex':
                true
            },
            key: 'pe_ineligible'
          },
          {
            condition: {
              'pe_cardiovascularSymptoms.pe_cardiovascularSymptoms_fainting':
                true
            },
            key: 'pe_ineligible'
          }
        ],
        els: 'pe_peyronies'
      }
    },
    'pe_cardiovascularSymptoms_details',
    {
      key: 'pe_peyronies',
      next: {
        condition: {
          'pe_peyronies.pe_peyronies_yes': true
        },
        key: 'pe_activeBending',
        els: 'pe_erectionPain'
      }
    },
    'pe_activeBending',
    'pe_erectionPain',
    'pe_tightForeskin',
    'pe_cardiacConditions',
    'pe_physicalConditions',
    {
      key: 'pe_mentalHealth',
      next: {
        condition: {
          'pe_mentalHealth.pe_mentalHealth_other': true
        },
        key: 'pe_mentalHealth_other_details',
        els: 'pe_suicidalThoughts'
      }
    },
    'pe_mentalHealth_other_details',
    'pe_suicidalThoughts',
    // {
    //   key: 'pe_suicidalThoughts',
    //   next: {
    //     condition: {
    //       'pe_suicidalThoughts.pe_suicidalThoughts_yes': true
    //     },
    //     key: 'pe_ineligible',
    //     els: 'pe_phq9Interest'
    //   }
    // },
    'pe_phq9Interest',
    'pe_phq9Hopeless',
    {
      key: 'pe_medicalConditions',
      next: {
        switch: [
          {
            condition: { 'pe_medicalConditions._prostateCancer': true },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_bph': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_bloodDisorders': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_kidney': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_pah': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_liver': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: { 'pe_medicalConditions.pe_medicalConditions_ms': true },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_spinal': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_neurological': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_ulcers': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_arrhythmias': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_glaucoma': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_visionLoss': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_hyponatremia': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_noSex': true
            },
            key: 'pe_medicalConditions_details'
          },
          {
            condition: {
              'pe_medicalConditions.pe_medicalConditions_heartAbnormalities':
                true
            },
            key: 'pe_medicalConditions_details'
          }
        ],
        els: 'pe_currentMedications'
      }
    },
    'pe_medicalConditions_details',
    'pe_currentMedications',
    'pe_recreationalDrugs',
    'pe_otherInformation',
    {
      key: 'pe_truthConsent',
      next: {
        condition: {
          'pe_truthConsent.pe_truthConsent_disagree': true
        },
        key: 'pe_ineligible',
        els: 'pe_treatmentConsent'
      }
    },
    {
      key: 'pe_treatmentConsent',
      next: {
        condition: {
          'pe_treatmentConsent.pe_treatmentConsent_disagree': true
        },
        key: 'pe_ineligible',
        els: 'pe_complete'
      }
    },
    'pe_ineligible',
    'pe_complete'
  ]
};
export const pe: FormType = {
  name: 'Premature Ejaculation',
  questions: [
    'pe1',
    'pe2-new',
    'pe3-new',
    'pe2',
    'pe3',
    'pe4',
    'pe5',
    'pe6',
    'pe6-new',
    'pe7-new',
    'peAcknowledgement'
  ]
};
